import { render } from "./Socials.vue?vue&type=template&id=ada77efe&scoped=true"
import script from "./Socials.vue?vue&type=script&lang=js"
export * from "./Socials.vue?vue&type=script&lang=js"

import "./Socials.vue?vue&type=style&index=0&id=ada77efe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ada77efe"

export default script